import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../action-button';
import IconButton from '../icon-button';
import { MODES } from './constants';
import { captionsType } from './types';
import { PublishButton } from './components';
import { useMatchLGBreakpoint } from '../../hooks';

const PreviewModeHeader = ({ captions, onBack, onPublish, onToggleMode, selectedMode }) => {
  const isLargeScreen = useMatchLGBreakpoint();

  const handleToggleMode = (mode) => () => onToggleMode(mode);

  return (
    <div className="ws-ui-preview-mode-header">
      <div className="ws-ui-preview-mode-header__left">
        <ActionButton
          size="small"
          format={isLargeScreen ? 'text' : 'solid-white'}
          iconPlacement="before"
          iconGlyph="back"
          onClick={onBack}
          label={isLargeScreen ? captions.back : null}
        />
      </div>
      <div className="ws-ui-preview-mode-header__center">
        <IconButton
          glyph="desktop"
          onClick={handleToggleMode(MODES.desktop)}
          selected={selectedMode === MODES.desktop}
        />
        <IconButton
          glyph="tablet"
          onClick={handleToggleMode(MODES.tablet)}
          selected={selectedMode === MODES.tablet}
        />
        <IconButton
          glyph="smartphone"
          onClick={handleToggleMode(MODES.mobile)}
          selected={selectedMode === MODES.mobile}
        />
      </div>
      <div className="ws-ui-preview-mode-header__right">
        <PublishButton onClick={onPublish} label={captions.publish} isCompact={!isLargeScreen} />
      </div>
    </div>
  );
};

PreviewModeHeader.propTypes = {
  captions: PropTypes.shape(captionsType).isRequired,
  onBack: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  onToggleMode: PropTypes.func.isRequired,
  selectedMode: PropTypes.oneOf(Object.values(MODES)).isRequired,
};

export default PreviewModeHeader;
